import React, { useState, useRef, useEffect } from 'react';
import './MessageReview.css';
import { ReactComponent as ThumbsUpIcon } from '../../Assets/Images/thumbs-up.svg';
import { ReactComponent as ThumbsDownIcon } from '../../Assets/Images/thumbs-down.svg';
import { ReactComponent as ArrowDownIcon } from '../../Assets/Images/arrow-down.svg';
import { ReactComponent as ArrowUpIcon } from '../../Assets/Images/arrow-up.svg';
import ReviewPopUp from './ReviewPopUp';
import { useDispatch, useSelector } from 'react-redux';
import {
  managePopUp,
  sendMessageFlag,
} from '../../store/Feedback/FeedbackActions';
import { getPopupState } from '../../store/Feedback/FeedbackSelectors';

const MessageReview = ({ message, user }) => {
  const dispatch = useDispatch();

  const [reviewSelected, setReviewSelected] = useState({
    value: message?.flag?.value || null,
    reason: message?.flag?.reason || null,
    description: message?.flag?.description || null,
  });
  const [reviewSent, setReviewSent] = useState(null);
  const [doesModalOpenInScreen, setDoesModalOpenInScreen] = useState(true);

  const { opened } = useSelector(getPopupState);

  const iconRef = useRef(null);
  const screenWidth = window.innerWidth;
  const bigScreen = screenWidth > 768;
  const modalHeight = 425;

  const sendFlag = async flag => {
    await dispatch(sendMessageFlag(user, message.id, flag));
    setReviewSent(flag);
    dispatch(
      managePopUp({
        opened: false,
      }),
    );
    return;
  };

  const disableScrollingForParents = () => {
    let element = iconRef.current?.parentElement;
    while (element) {
      element.style.overflow = 'hidden';
      element = element.parentElement;
    }
  };

  const enableScrollingForParents = () => {
    let element = iconRef.current?.parentElement;
    while (element) {
      element.style.overflow = 'auto';
      element = element.parentElement;
    }
  };

  useEffect(() => {
    if (opened) {
      disableScrollingForParents();
    } else {
      enableScrollingForParents();
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [opened]);

  const manageOpenModal = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();

      const isNearTop = rect.top < modalHeight + 35;

      const distanceToBottom = window.innerHeight - rect.bottom;
      const isNearBottom = distanceToBottom < modalHeight;

      if (isNearTop && isNearBottom) {
        setDoesModalOpenInScreen(false);
        console.log('to close to top and bottom to open modal');
        return;
      }

      setDoesModalOpenInScreen(true);

      const newTopPosition = isNearTop
        ? rect.top + 20 // Open downwards
        : rect.top - modalHeight - 35; // Open upwards

      !opened &&
        dispatch(
          managePopUp({
            opened: true,
            position: {
              top: newTopPosition,
              left: rect.right + 10,
            },
          }),
        );
    }
  };

  const manageModalClose = () => {
    if (reviewSelected.reason !== reviewSent?.reason || !reviewSent?.reason) {
      setReviewSelected(reviewSent);
      dispatch(
        managePopUp({
          view: 'options',
        }),
      );
    }
    dispatch(
      managePopUp({
        opened: false,
      }),
    );
  };

  const thumbPress = async (flag: 'good' | 'bad') => {
    if (flag === reviewSelected.value) {
      sendFlag({ value: null, reason: null, description: null });
      setReviewSelected({ value: null, reason: null, description: null });
      dispatch(
        managePopUp({
          opened: false,
        }),
      );
      return;
    }

    await sendFlag({ value: flag, reason: null, description: null });
    if (flag === 'bad' && bigScreen) {
      manageOpenModal();
    } else {
      dispatch(
        managePopUp({
          opened: false,
        }),
      );
    }
    setReviewSelected({ value: flag, reason: null, description: null });
  };

  if (!message.id) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <button
        className="thumpWrapper"
        onClick={() => thumbPress('good')}
        style={{
          backgroundColor: '#ffffff',
          color: '#5f5a58',
          opacity: reviewSelected.value === 'good' ? 1 : 0.4,
        }}
      >
        <ThumbsUpIcon
          style={{
            width: '20px',
            height: '20px',
          }}
        />
      </button>

      <button
        className="thumpWrapper"
        onClick={() => thumbPress('bad')}
        style={{
          backgroundColor: '#ffffff',
          color: '#5f5a58',
          opacity: reviewSelected.value === 'bad' ? 1 : 0.4,
        }}
      >
        <ThumbsDownIcon
          style={{
            width: '20px',
            height: '20px',
          }}
          ref={iconRef}
        />
      </button>
      {reviewSelected.value === 'bad' && (
        <button
          className="thumpWrapper"
          onClick={() => (opened ? manageModalClose() : manageOpenModal())}
          style={{
            backgroundColor: '#ffffff',
            color: '#5f5a58',
            opacity: reviewSelected.value === 'bad' ? 1 : 0.4,
          }}
        >
          {bigScreen &&
            doesModalOpenInScreen &&
            (opened ? (
              <ArrowUpIcon style={{ width: '25px', height: '25px' }} />
            ) : (
              <ArrowDownIcon style={{ width: '25px', height: '25px' }} />
            ))}
        </button>
      )}

      {opened && (
        <ReviewPopUp
          reviewSelected={reviewSelected}
          setReviewSelected={setReviewSelected}
          sendFlag={sendFlag}
          modalHeight={modalHeight}
        />
      )}
    </div>
  );
};

export default MessageReview;
